export const PLAN_READ_REQUEST = 'PLAN_READ_REQUEST';
export const PLAN_READ_SUCCESS = 'PLAN_READ_SUCCESS';
export const PLAN_READ_FAIL = 'PLAN_READ_FAIL';
export const PLAN_SAVE_REQUEST = 'PLAN_SAVE_REQUEST';
export const PLAN_SAVE_SUCCESS = 'PLAN_SAVE_SUCCESS';
export const PLAN_SAVE_FAIL = 'PLAN_SAVE_FAIL';